import { render, staticRenderFns } from "./QuestionSelector.vue?vue&type=template&id=a29dd310&scoped=true"
import script from "./QuestionSelector.vue?vue&type=script&lang=js"
export * from "./QuestionSelector.vue?vue&type=script&lang=js"
import style0 from "./QuestionSelector.vue?vue&type=style&index=0&id=a29dd310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29dd310",
  null
  
)

export default component.exports